import React, { useState } from 'react';
import { withStyles, Grid, IconButton } from '@material-ui/core';
import { CardModuleUI, ToggleUI } from '../../common';
import MessageStepsDoneText from './MessageStepsDoneText';

const MessageStepsDone_ = (props) => {
  const [open, setOpen] = useState(true);

  const icon = (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
        fill="#A5A5A5"
      />
    </svg>
  );

  const { classes, title } = props;
  return (
    <>
      <ToggleUI show={open}>
        <CardModuleUI>
          <Grid container>
            <Grid item xs={12}>
              <div className={classes.container_title}>
                <h3 className={classes.title}>{title}</h3>
                <IconButton
                  key="close"
                  aria-label="Close"
                  color="inherit"
                  className={classes.icon_button}
                  onClick={(e) => setOpen(false)}
                >
                  {icon}
                </IconButton>
              </div>
            </Grid>
            <Grid item xs={12}>
              <MessageStepsDoneText classes={classes} />
            </Grid>
          </Grid>
        </CardModuleUI>
      </ToggleUI>
    </>
  );
};

const styles = (theme) => ({
  container_title: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '12px',
  },
  container_message: {
    margin: '12px 0px 12px 0px',
  },
  title: {
    fontWeight: '600',
    fontSize: '1.5rem',
    lineHeight: '28px',
    color: '#53B755',
    margin: '0px',
  },
  message: {
    fontWeight: '400',
    fontSize: '1.12rem',
    lineHeight: '24px',
    color: '#6F6F6F',
    margin: '0px',
  },
  icon_button: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  link: {
    color: '#6F6F6F',
    textDecoration: 'underline !important',
  },
});
export const MessageStepsDone = withStyles(styles)(MessageStepsDone_);
